<div>
  <app-additional-filters *ngIf="years"
                          [years]="years"
                          [categories]="categories"
                          (search)="searchData($event)">
  </app-additional-filters>
  <mat-divider></mat-divider>
  <app-cost-additional-benchmark-chart *ngIf="data"
                                       [title]="text"
                                       [subtitle]="subtitle"
                                       [data]="data.chartData"
                                       [lastModifiedDate]="data.lastModifiedDate"
                                       [weeeSystem]="data.weeeSystemName"
                                       [datasets]="datasets"
  >
  </app-cost-additional-benchmark-chart>
</div>
